module.exports = __webpack_public_path__ + "assets/CircleTangentLDetailed.1a522641eea2f86364b01ed5a07ca0c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/CircleTangentLDetailed.png
// module id = 494
// module chunks = 0